import React from 'react';
import i18next from 'i18next';
import { Node } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const Experts = ({ experts }) => {
  return (
    <Container small>
      <div className="Experts">
        <h2>{i18next.t('components.experts.title')}</h2>

        <div className="Experts__items">
          {experts.map((expert) => {
            return (
              <Node
                entity={expert.getIn(['entity'])}
                id={expert.getIn(['target_id'])}
                key={expert.getIn(['target_id'])}
                viewMode="teaser"
              />
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default Experts;
